import React, { FunctionComponent, ReactElement, memo, useEffect } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { logComponentDeprecation } from '../../../utils/Deprecation'

export type ShareButtonProps = {
    /**
     * callback function triggered when button is pressed
     *
     * @TJS-type function
     */
    onShare: () => void
    /** shows dark styled button (transparent-grey background) if true, default backgroundColor is white */
    isDark?: boolean
} & TestID

const ShareButton: FunctionComponent<ShareButtonProps> = ({
    onShare,
    isDark,
    testID,
}): ReactElement => {
    /* istanbul ignore next */
    useEffect(() => {
        logComponentDeprecation('ShareButton')
    }, [])

    return (
        <Touchable onPress={onShare} testID={testID}>
            <Grid
                noExpand
                center
                width={44}
                height={44}
                borderRadius={22}
                backgroundColor={isDark ? 'pearl-opacity-35' : 'pearl'}
            >
                <FontelloIcon
                    name="share-android"
                    textAlign="center"
                    color={isDark ? 'pearl' : 'onyx'}
                    fontSize={20}
                />
            </Grid>
        </Touchable>
    )
}

export default memo(ShareButton)
